import productImg from "../../assets/img/product-ov-6-free-shipping.png";
import productImgWebp from "../../assets/img/product-ov-6-free-shipping.webp";
import cardsImg from "../../assets/img/cards.png";
import cardsImgWebp from "../../assets/img/cards.webp";

const Offer = () => (
    <section id="offer">
        <div className="container-fluid gg-bg-solid-blue text-white">
            <div className="row justify-content-center align-content-center text-center py-3 gg-bg-solid-yellow-light text-black">
                <div className="col-xxl-5 col-xl-7 col-lg-8 col-11">
                    <h1 className="fw-bold">SELECT CUSTOMERS ONE-TIME ONLY OFFER</h1>
                </div>
            </div>
            <div className="row justify-content-center align-content-center pt-5">
                <div className="col-xxl-8 col-lg-10 col-11 py-5 px-xxl-4 px-3 gg-border-radius">
                    <div className="row justify-content-center">
                        <div className="col-xxl-4 col-lg-5 col-md-5 col-12 align-content-center text-center">
                            <h1 className="gg-text-highlight-green mb-2">SAVE $900</h1>
                            <picture>
                                <source srcSet={productImgWebp} type="image/webp" />
                                <img className="img-fluid gg-border-radius" src={productImg} loading="lazy" />
                            </picture>
                            <h3 className="mt-5">
                                <span className="text-uppercase">6 Bottles </span>
                                <span className="text-white-50 text-uppercase">for just</span>
                            </h3>
                            <h3>
                                <s className="text-white-50">$1074</s>
                                <span className="text-uppercase ms-1">$174</span>
                            </h3>
                        </div>
                        <div className="col-md-6 col-12 mt-lg-0 mt-3 pe-md-0 text-md-start text-center align-content-center">
                            <h2 className="mt-lg-4 mb-5">Upgrade now with <b>6 BOTTLES</b> of OptiVista at The HUGE Discount of Just <s>$179</s> <b>$29 per bottle</b>!</h2>
                            <h2 className="fw-bold mb-5">Includes Free US Shipping</h2>
                            <p><b>Ready to See Life Clearly Again?</b><br />Experience sharper vision and renewed eye comfort today.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center text-center gg-bg-solid-blue">
                <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-7 col-10 ">
                    <a href="https://buygoods.com/secure/upsell/?account_id=11273&product_codename=opt6&redirect=aHR0cHM6Ly9idXlnb29kcy5jb20vdGhhbmt5b3U/YWNjb3VudF9pZD0xMTI3Mw==" className="text-decoration-none btn gg-button-buy-yellow gg-buy-card-button gg-bigger-button fw-bold text-uppercase gtm-buy-btn" data-gtm-label="OptiVista Upsell 6 - Offer - Yes Button" data-gtm-product="opt6" data-gtm-price="174">Get Your Supply Now</a>
                </div>
            </div>
            <div className="row justify-content-center text-center mt-4 pb-5">
                <div className="col-xxl-6 col-xl-7 col-lg-8 col-sm-10">
                    <div className="mb-5">
                        <a href="https://buygoods.com/secure/upsell/?account_id=11273&product_codename=opt6&redirect=aHR0cHM6Ly9idXlnb29kcy5jb20vdGhhbmt5b3U/YWNjb3VudF9pZD0xMTI3Mw==" className="text-white gtm-buy-btn" data-gtm-label="OptiVista Upsell 6 - Offer - Yes Link" data-gtm-product="opt6" data-gtm-price="174">Yes, I'd like to experience clearer, sharper vision and protect my eyesight naturally. Please upgrade my order now and apply the biggest discount.</a>
                    </div>
                    <a href="https://buygoods.com/thankyou?account_id=11273" className="text-white-50 gg-small-text gg-link gtm-no-ud-btn" data-gtm-label="OptiVista Upsell 6 - Offer - No Link" data-gtm-product="opt6" data-gtm-price="174">No Thanks, I Don’t Want To Benefit From This Unique Offer. I Understand That When I Order More GlucoGen<sup>17</sup> Naturals, This One-Time-Only Discount Will No Longer Be Available.</a>
                    <div className="mt-4">
                        <picture>
                            <source srcSet={cardsImgWebp} type="image/webp" />
                            <img className="img-fluid gg-cards-max-height" src={cardsImg} loading="lazy" />
                        </picture>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default Offer;